<template>
  <div class="rounded" style="background-color: white; position: relative;">
    <img src="@/assets/money_rain_rewards.svg" />
    <div class="overlay mt-n12">Coming Soon</div>
  </div>
</template>

<script>
export default {
  name: 'ComingSoon',
}
</script>

<style scoped>
  .overlay {
    bottom: 0px;
    left: 0px;
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 48px;
    font-weight: bold;
    color: #CDCDCD;
    text-align: center;
  }
</style>